import React from 'react'
import ReactDOM from 'react-dom/client'
import './global.css'
import '@fontsource/inter/latin-200.css'
import '@fontsource/inter/latin-300.css'
import '@fontsource/inter/latin-400.css'
import '@fontsource/inter/latin-500.css'
import '@fontsource/inter/latin-600.css'
import '@fontsource/inter/latin-800.css'
import App from './App'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import { setupSentry } from './util/sentry'

setupSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
)
